module.exports = __webpack_public_path__ + "static/media/supplier-code.6e6b30fc.svg";